import { PortalError } from './PortalError';

export class PrescriptionDeactivateError extends PortalError {
  constructor() {
    super('PrescriptionDeactivateError', 'Prescription(s) not deactivated', 'prescript_deactivated_error');
  }
}
